import { type QueryClient, useQueryClient } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";
import { WS_EVENT_TYPES } from "utils";

import { useEventSubscription, useOnWSReconnect } from "src/events";
import { getCommentsQueryKeyPrefix } from "src/queries/comments";

// Notification caches are owned by NotificationsRealtimeProvider.
function invalidateCommentCaches(
  queryClient: QueryClient,
  workoutId: string,
): void {
  queryClient.invalidateQueries({
    queryKey: getCommentsQueryKeyPrefix(workoutId),
  });
  queryClient.invalidateQueries({ queryKey: ["comments", "author-comments"] });
  queryClient.invalidateQueries({
    queryKey: ["workflows", "workflow-recipients"],
  });
  queryClient.invalidateQueries({ queryKey: ["workflows", "participants"] });
}

export function CommentsRealtimeProvider(props: PropsWithChildren) {
  const queryClient = useQueryClient();

  useEventSubscription(WS_EVENT_TYPES.COMMENT_ADDED, (event) => {
    invalidateCommentCaches(queryClient, event.payload.workoutId);
  });

  useEventSubscription(WS_EVENT_TYPES.COMMENT_READ, (event) => {
    invalidateCommentCaches(queryClient, event.payload.workoutId);
  });

  useOnWSReconnect(() => {
    queryClient.invalidateQueries({ queryKey: ["comments"] });
    queryClient.invalidateQueries({
      queryKey: ["workflows", "workflow-recipients"],
    });
    queryClient.invalidateQueries({
      queryKey: ["workflows", "participants"],
    });
  });

  return <>{props.children}</>;
}
